import React from "react";
import { ConnectorLogo } from "../../atoms/ConnectorLogo";
import { Row, TitleBlock, DisplayName, ProviderLabel } from "./ConnectorIdentity.styles";
import type { ConnectorIdentityProps } from "./ConnectorIdentity.types";

export const ConnectorIdentity: React.FC<ConnectorIdentityProps> = ({
  displayName,
  iconUrl,
  providerLabel,
  className,
}) => (
  <Row className={className}>
    <ConnectorLogo src={iconUrl} name={displayName} size="md" />
    <TitleBlock>
      <DisplayName>{displayName}</DisplayName>
      {providerLabel ? <ProviderLabel>{providerLabel}</ProviderLabel> : null}
    </TitleBlock>
  </Row>
);

export default ConnectorIdentity;
